import { LoginResponse } from '@shared/api/rest/auth';
import { create } from 'zustand';

interface UserState {
  hasTCConfirmation: boolean;
  name: string;
  last_login: string | null;
  status: string;
}

interface UserActions {
  authSuccess: (payload: LoginResponse) => void;
  reset: () => void;
}

const initialState: UserState = {
  hasTCConfirmation: false,
  name: '',
  last_login: null,
  status: '',
};

export const useUserStore = create<UserState & UserActions>()((set) => ({
  ...initialState,

  authSuccess: (payload) =>
    set(() => ({
      name: payload.name,
      last_login: payload.last_login,
      status: payload.status,
    })),

  reset: () => set(initialState),
}));
